import { useEffect, useState, useCallback } from 'react'

export function useDarkMode() {
  const [isDark, setIsDark] = useState(false)

  // Set initial theme based on saved preference or system
  useEffect(() => {
    const savedTheme =
      typeof window !== 'undefined' ? localStorage.getItem('efficient:theme') : null
    const prefersDark =
      typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches

    if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
      document.documentElement.classList.add('dark')
      setIsDark(true)
    } else {
      document.documentElement.classList.remove('dark')
      setIsDark(false)
    }
  }, [])

  // Toggle theme and persist preference
  const toggleTheme = useCallback(() => {
    if (document.documentElement.classList.contains('dark')) {
      document.documentElement.classList.remove('dark')
      localStorage.setItem('efficient:theme', 'light')
      setIsDark(false)
    } else {
      document.documentElement.classList.add('dark')
      localStorage.setItem('efficient:theme', 'dark')
      setIsDark(true)
    }
  }, [])

  return { isDark, toggleTheme }
}
